import React from "react";
import Header from "./Header";
import PropTypes from "prop-types";
import Footer from "./Footer";
import Sidebar from "./Sidebar";
import { useSidebarContext } from "../Context/SidebarContext";
import ErrorMessage from "../Component/ErrorMessage";
import { useAlertContext } from "../Context/AlertContext";
import SuccessMessage from "../Component/SuccessMessage";

const NAV_ITEMS = {
  Home: "/home",
  "Engine Config": "/engine-config",
  "API Generator": "/api-generator",
  "My APIs": "/my-apis",
  "Get Token": "/gettoken"
};

const Layout = ({ children, variant }) => {
  const { showingSidebar, setShowingSidebar } = useSidebarContext();
  const { errors, successMessage } = useAlertContext();
  const isDashboard = variant === "dashboard";
  const handleCloseSidebar = () => {
    setShowingSidebar(false);
  };
  return (
    <div className="relative flex flex-col h-screen max-w-screen-3xl mx-auto">
      <Header navItems={NAV_ITEMS} />
      <Sidebar show={showingSidebar} onClose={handleCloseSidebar} navItems={NAV_ITEMS} />
      <ErrorMessage errors={errors} />
      <SuccessMessage message={successMessage} />
      <main
        className={`flex flex-col flex-auto overflow-hidden ${
          isDashboard ? "bg-[#060D1F] text-[#F1F5FF]" : "bg-gray-100 text-gray-700"
        }`}>
        <div className={`flex min-h-0 flex-col flex-auto overflow-auto ${isDashboard ? "p-0" : "p-6"}`}>
          <div
            className={`flex w-full min-h-0 flex-auto flex-col ${
              isDashboard ? "" : "mx-auto max-w-screen-2xl"
            }`}>
            {children}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.element.isRequired,
  variant: PropTypes.string
};

export default Layout;
